// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MultilingualStringWithLink
 */
export interface MultilingualStringWithLink {
  /**
   *
   */
  _default: string | null;
  /**
   *
   */
  link?: string | null;
}

/**
 * Check if a given object implements the MultilingualStringWithLink interface.
 */
export function instanceOfMultilingualStringWithLink(
  value: object
): value is MultilingualStringWithLink {
  if (
    (!("_default" in (value as Record<string, any>)) &&
      !("default" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["_default"] === undefined &&
      (value as Record<string, any>)["default"] === undefined)
  )
    return false;
  return true;
}

export function MultilingualStringWithLinkFromJSON(json: any): MultilingualStringWithLink {
  return MultilingualStringWithLinkFromJSONTyped(json, false);
}

export function MultilingualStringWithLinkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MultilingualStringWithLink {
  if (json == null) {
    return json;
  }
  return {
    _default: json["default"],
    link: json["link"] === undefined ? undefined : json["link"] === null ? null : json["link"],
  };
}

export function MultilingualStringWithLinkToJSON(json: any): MultilingualStringWithLink {
  return MultilingualStringWithLinkToJSONTyped(json, false);
}

export function MultilingualStringWithLinkToJSONTyped(
  value?: MultilingualStringWithLink | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    default: value["_default"],
    link: value["link"],
  };
}
